<div class="row">
    <div [ngClass]="isEdit || isAdd ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.employeeId)"><i class="fas fa-pencil-alt"></i></button>
                    <!--<button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.employeeId)"><i class="fas fa-times"></i></button>-->
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="employeeId" title="ID"></kendo-grid-column>
            <kendo-grid-column field="firstName" title="First Name"></kendo-grid-column>
            <kendo-grid-column field="lastName" title="Last Name"></kendo-grid-column>
            <kendo-grid-column field="fullName" title="Full Name"></kendo-grid-column>
            <kendo-grid-column field="title" title="Title"></kendo-grid-column>
            <kendo-grid-column field="winUserName" title="Win Username"></kendo-grid-column>
            <kendo-grid-column field="erpUserId" title="ERP User ID"></kendo-grid-column>
            <kendo-grid-column field="webId" title="Web ID"></kendo-grid-column>
            <kendo-grid-column field="email" title="Email"></kendo-grid-column>
            <kendo-grid-column field="phone" title="Phone"></kendo-grid-column>
            <kendo-grid-column field="phoneExt" title="Ext"></kendo-grid-column>
            <kendo-grid-column field="cell" title="Cell"></kendo-grid-column>
            <kendo-grid-column field="startDate" title="Start">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.startDate | date: 'M/dd/yy'}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="endDate" title="End">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.endDate | date: 'M/dd/yy'}}
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-column field="fax" title="Fax"></kendo-grid-column>-->
            <kendo-grid-column field="departmentId" title="Department">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.departmentId > 0">{{getDepartment(dataItem.departmentId)}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="managerId" title="Manager">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.managerId > 0">{{getManager(dataItem.managerId)}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="managerInd" title="Mgr?">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.managerInd" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="activeInd" title="Active?">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.activeInd" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isEdit || isAdd">
        <!-- Edit form -->
        <employee-form [tableID]="tableID" (onRefresh)="cancelEdit()"></employee-form>
    </div>
</div>
